import { footerColumns } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="border-t border-secondary-200 bg-secondary-100">
      <div className="mx-auto max-w-[1400px] px-4 py-12 md:px-8 md:py-14">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-bold text-background-50">
                曝
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">
                网曝黑料
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              追踪报道 · 官方通报同步 · 快人一步掌握动态。把零散线索聚合成可追溯的进展流，让每一条后续瓜都有据可查。
            </p>
            <div className="mt-5 flex flex-wrap gap-3">
              <a
                href="#latest"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-3 py-2 text-xs text-foreground-700 transition-colors hover:text-primary-600"
              >
                <i className="ri-refresh-line" />
                查看最新进展
              </a>
              <a
                href="#topics"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-3 py-2 text-xs text-foreground-700 transition-colors hover:text-primary-600"
              >
                <i className="ri-bookmark-line" />
                订阅追踪专题
              </a>
            </div>
          </div>

          {footerColumns.map((column) => (
            <div key={column.title} className="lg:col-span-2">
              <h4 className="font-heading text-sm font-bold text-foreground-950">
                {column.title}
              </h4>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link}>
                    <a
                      href="#top"
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="lg:col-span-1">
            <h4 className="font-heading text-sm font-bold text-foreground-950">关注</h4>
            <div className="mt-4 flex flex-wrap gap-2 lg:flex-col">
              <a
                href="#top"
                aria-label="微博"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-700 transition-colors hover:text-primary-600"
              >
                <i className="ri-weibo-line" />
              </a>
              <a
                href="#top"
                aria-label="微信"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-700 transition-colors hover:text-primary-600"
              >
                <i className="ri-wechat-line" />
              </a>
              <a
                href="#top"
                aria-label="邮箱"
                className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-foreground-700 transition-colors hover:text-primary-600"
              >
                <i className="ri-mail-line" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 网曝黑料 · 内容为公开信息聚合整理，涉及侵权请联系处理。</p>
          <p>本页展示内容为演示数据，请以官方通报为准。</p>
        </div>
      </div>
    </footer>
  );
}